import { QUEST_ACTION } from '../../constants/actions'

const changeQuestState = (property, value) => ({
  type: QUEST_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const changeQuestListState = (property, value) => ({
  type: QUEST_ACTION.CHANGE_LIST_STATE,
  payload: {
    property,
    value
  }
})

const createQuest = (file) => {
  return {
    type: QUEST_ACTION.ON_CREATE_INIT_QUEST,
    payload: { file }
  }
}

const updateQuest = (file, quest) => {
  return {
    type: QUEST_ACTION.ON_UPDATE_INIT_QUEST,
    payload: { file, quest }
  }
}

const toggleQuest = (id, data) => {
  return {
    type: QUEST_ACTION.ON_TOGGLE_QUEST,
    payload: {
      quest: { id, data }
    }
  }
}

const resetQuestState = () => ({
  type: QUEST_ACTION.RESET_STATE
})

const getQuests = () => ({
  type: QUEST_ACTION.ON_GET_QUESTS
})

const resetQuestsList = () => ({
  type: QUEST_ACTION.ON_RESET_LIST
})

const selectQuest = (data, isListUpdate = false) => ({
  type: QUEST_ACTION.ON_SELECT,
  payload: { data, isListUpdate }
})

export {
  changeQuestState,
  changeQuestListState,
  createQuest,
  resetQuestState,
  getQuests,
  updateQuest,
  toggleQuest,
  resetQuestsList,
  selectQuest
}
